module.exports = __webpack_public_path__ + "static/media/drag-move-lesson.4bdaf775.svg";